import { Injectable } from "@angular/core";

export interface SharedServiceConfig {
  restServer: string;
}

export interface FilterTerm {
  term: string,
  values: FilterTermValue[]
}

export interface FilterTermValue {
  id: number,
  annotation_value?: string,
  full_name?: string,
  sub_values?: FilterSubValue[]
}

export interface FilterSubValue {
  value_id: number, 
  value_text?: string,
}

export interface Message {
  id: number;
  key: string;
  type: MessageType;
  username: string;
  value: string;
  date_created: string;
  date_updated: string
}

export enum SortDirection {
  ASCENDING = 'asc',
  DESCENDING = 'desc'
}

export enum MessageType {
  INFO = 'Information',
  SUCCESS = 'Success',
  ERROR = 'Error'
}

/**
 * Base page state used when navigating from a list view to a form view
 * Each list component may extend this with additional fields
 */
export interface ListPageState {
  currentPage: number;
  pageSize: number;
  first: number;
  filterValue: string;
  totalRows?: number;
}

/**
 * A PagedResponse is a generic interface to handle
 * native Django API responses which include
 * count and paging data, and optionally permissions data
 */
export interface PagedResponse {
  count: number;
  next: string;
  previous: string;
  results: unknown[]
}

export interface Comment {
  name: string;
  value: string;
  id?: number;
}

@Injectable({
  providedIn: 'root',
})

export class SharedServiceTypes {
}